export const locale = {
  lang: 'en-CA',
  data: {
    MATERIAL_COMBO_PANEL: {
      TITLE: 'Edit kit',
      TITLE_CREATE: 'New kit',
      LEFT_LIST_LABEL: 'Drag & drop or use the + button to add equipment',
      RIGHT_LIST_LABEL: 'Reorder, adjust or remove equipment from the kit',
      CREATE_MATERIAL: 'Create an equipment',
      SEARCH: 'search by internal name, external name or material code',
      SEARCH_MATERIAL: 'Perform a search for your equipment.',
      CATEGORY_FILTER: 'Equipment category',
      TAGS_FILTER: 'Tags',
      NO_SEARCH_RESULTS: 'No results for your search.',
      NO_SEARCH_RESULTS_TRY_AGAIN: 'Please try something else.',
      INTERNAL_VIEW_ONLY: 'Internal view only',
      INTERNAL_VIEW_ONLY_SHORT: 'Internal',
      SHOW_UNIT_PRICE: 'Show unit price',
      SHOW_UNIT_PRICE_SHORT: 'Price',
      REMOVE_ITEM: 'Remove from kit',
    },
  },
};
